export default "__VITE_ASSET__Cgr0gW4Z__"